import { useId } from 'react'

import { useDisabled, type DisabledState } from './disabled.tsx'

import './form.css'

/**
 * 라디오 — 여럿 중 «하나만» 고른다(작업 추가 창 레시피 표 · eric 2026-10-21 「라디오 버튼을 하나만 선택하게 해주고」).
 * `Checkbox` 와 같은 꼴 · 같은 비활성 규약(숨기지 않고 비활성 + 사유)이고 모양만 둥글다 — 둥근 것이 「하나만」이라는 뜻이다
 * (`form.css` `.a-chk__input` 머리말: 네모 = 여러 개). 같은 `name` 을 준 것끼리 한 묶음이다(방향키 이동은 브라우저 몫).
 * ⚠ 선택 몇 개짜리 짧은 고르기는 `Segmented` 다 — 이것은 표의 줄처럼 고를 것이 많고 줄마다 서야 할 때 쓴다.
 */
export type RadioProps = {
  checked: boolean
  onChange?: (() => void) | undefined
  /** 라벨(한글). 라디오 옆에 보인다 — 접근 이름이다 */
  label: string
  /** 같은 묶음의 이름 */
  name: string
  value: string
} & DisabledState

export function Radio({
  checked,
  onChange,
  label,
  name,
  value,
  disabled,
  disabledReason,
}: RadioProps) {
  const id = useId()
  const { isDisabled, ariaProps, reasonNode } = useDisabled(disabled, disabledReason)

  return (
    <>
      <label className="a-chk" htmlFor={id} title={ariaProps.title}>
        <input
          aria-describedby={ariaProps['aria-describedby']}
          aria-disabled={ariaProps['aria-disabled']}
          checked={checked}
          className="a-chk__input a-chk__input--radio"
          id={id}
          name={name}
          onChange={isDisabled ? undefined : () => onChange?.()}
          readOnly={isDisabled}
          type="radio"
          value={value}
        />
        {label}
      </label>
      {reasonNode}
    </>
  )
}
